<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <OsForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OsForm from '@/components/os/OsForm'

export default {
  name: 'OsAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    OsForm
  }
}
</script>